import React from "react";
import { Icon } from "@chakra-ui/react";

export const MinusIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M14 2H0V0H14V2Z" fill="#1A1A1A" />
    </Icon>
  );
};
